import {Button,Card, Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';


function LocationItem(props) {
  function centerButton(e) {
    e.preventDefault();
    console.log(e.target.id);
    console.log('The link has been  clicked.');
    props.setSelectedCenter(e.target.id);
    props.setTimezone (e.target.name);
    props.setFormValidated(true);
  }
  return (
    <Col md={{ span: 4, offset: 1 }}>
    <Card style={{ width: '18rem' }}>
      <Card.Body>
    <Card.Title>{props.name}</Card.Title>
    <Card.Subtitle>{props.phone}</Card.Subtitle>
    <Card.Text>
    {props.street}
    {props.city}, {props.state} {props.zip} 
    </Card.Text>
    <Button id={props.centerId}  name={props.timezone} onClick={centerButton} variant="primary" size="sm">
    Select
  </Button>
      </Card.Body>
    </Card>
    </Col>); 
}

export default LocationItem;